import { useEffect, useState } from 'react';
import { getMe } from '../services/vault/me';
import { extractErrorMessage } from '../util/errorMessage';

const SALES_REP_PERMISSIONS = [
  'fundraiser:basic_edit',
  'raise_access:sales_manager',
  'raise_access:salesrep',
  'raise_access:sales',
  'raise_access:internal_salesrep',
  'raise_access:sales_trainer',
];

const SUPER_ADMIN_PERMISSIONS = [
  'fundraiser:edit',
  'fundraiser:financials_edit',
  'raise_access:superadmin',
  'user:edit',
];

export const isUserSuperAdmin = (permissions: string[]): boolean =>
  permissions.some((p) => SUPER_ADMIN_PERMISSIONS.includes(p));

const isUserSalesRep = (permissions: string[]): boolean =>
  permissions.some((p) => SALES_REP_PERMISSIONS.includes(p));

export default function useUserPublicInfo(): {
  canEditKyc: boolean;
  errorMessage?: string;
  isFinished: boolean;
} {
  const [canEditKyc, setCanEditKyc] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const getUser = async (): Promise<void> => {
      try {
        const { permissions } = await getMe();
        if (isUserSalesRep(permissions)) {
          setCanEditKyc(isUserSuperAdmin(permissions));
        } else {
          setCanEditKyc(true);
        }
      } catch (e) {
        setErrorMessage(extractErrorMessage(e));
      } finally {
        setIsFinished(true);
      }
    };
    getUser();
  }, []);

  return { canEditKyc, errorMessage, isFinished };
}
